// model based on API::V1::Activity::V1::BasicContentSerializer
export default {

  // Images
  background_image: null,
  gradient_start: null,
  gradient_end: null,

  // Attributes
  identifier: null,
  label: null,
  headline: null,
  content: null,
  hype_translations: null,
  hype_orientation: null
}
